<script>
  import Home from "./routes/Home.svelte";
  import PrivacyPolicy from "./routes/PrivacyPolicy.svelte";
  import Terms from "./routes/Terms.svelte";
  import AccountDeletion from "./routes/AccountDeletion.svelte";
  import Support from "./routes/Support.svelte";
  import SeoPage from "./routes/SeoPage.svelte";
  import Resources from "./routes/Resources.svelte";
  import NotFound from "./routes/NotFound.svelte";
  import { contentBySlug } from "./content.js";

  const routes = {
    "/": Home,
    "/privacy": PrivacyPolicy,
    "/privacy-policy": PrivacyPolicy,
    "/terms": Terms,
    "/account-deletion": AccountDeletion,
    "/support": Support,
    "/resources": Resources,
  };

  const legacyPath = window.location.hash.startsWith("#/")
    ? window.location.hash.slice(1)
    : null;
  const rawPath = legacyPath && routes[legacyPath]
    ? legacyPath
    : window.location.pathname;
  const initialPath = rawPath.length > 1 ? rawPath.replace(/\/$/, "") : rawPath;

  if (legacyPath && routes[legacyPath]) {
    window.history.replaceState(null, "", legacyPath);
  }

  const contentPage = contentBySlug[initialPath];
  const Page = contentPage ? SeoPage : (routes[initialPath] || NotFound);
</script>

{#if contentPage}<svelte:component this={Page} page={contentPage} />{:else}<svelte:component this={Page} />{/if}
